// extracted by mini-css-extract-plugin
export default {"svgContainer":"PlaceholderBox_svgContainer__+blKo"};